import { ApiError } from "@/api/client";
import { CLICK_STYLE_FALLBACK } from "@/config/uiTokens";

interface Props {
  error: unknown;
}

export default function AuthErrorPage({ error }: Props) {
  const isApiError = error instanceof ApiError;
  const message = isApiError
    ? error.message
    : error instanceof Error
      ? error.message
      : "Noma'lum xatolik yuz berdi";

  const statusCode = isApiError ? error.status : null;
  const traceId = isApiError ? error.traceId : null;
  const path = isApiError ? error.path : null;

  const s: Record<string, React.CSSProperties> = {
    root: {
      minHeight: "100dvh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "20px",
      padding: "32px 24px",
      textAlign: "center",
      background: "var(--app-bg, #000000)",
      fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif",
    },
    iconWrap: {
      width: 72,
      height: 72,
      borderRadius: "50%",
      background: "rgba(239,68,68,0.12)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },
    title: {
      margin: "0 0 10px",
      fontSize: 18,
      fontWeight: 800,
      color: "var(--c-text, #e7f5ee)",
    },
    message: {
      margin: 0,
      fontSize: 14,
      color: "var(--c-text-faint, #9fb8aa)",
      lineHeight: 1.6,
    },
    detailBox: {
      marginTop: 14,
      padding: "10px 14px",
      borderRadius: 12,
      background: "rgba(239,68,68,0.07)",
      border: "1px solid rgba(239,68,68,0.18)",
      textAlign: "left",
      fontSize: 11,
      color: "var(--c-text-faint, #9fb8aa)",
      lineHeight: 1.7,
      maxWidth: 320,
      wordBreak: "break-all",
    },
    detailRow: {
      display: "flex",
      gap: 6,
    },
    label: {
      color: "rgba(239,68,68,0.7)",
      fontWeight: 700,
      flexShrink: 0,
    },
    retryBtn: {
      display: "inline-block",
      marginTop: 4,
      padding: "14px 36px",
      borderRadius: 16,
      background: `var(--click-button-primary-bg, ${CLICK_STYLE_FALLBACK.ctaGradient})`,
      color: `var(--click-button-primary-fg, ${CLICK_STYLE_FALLBACK.onCta})`,
      fontSize: 15,
      fontWeight: 700,
      border: "none",
      cursor: "pointer",
    },
  };

  return (
    <div style={s.root}>
      <div style={s.iconWrap}>
        <svg width="36" height="36" fill="none" viewBox="0 0 24 24" stroke="#ef4444" strokeWidth="1.5">
          <path strokeLinecap="round" strokeLinejoin="round"
            d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
        </svg>
      </div>

      <div style={{ maxWidth: 320 }}>
        <p style={s.title}>Tizimga kirishda xatolik</p>
        <p style={s.message}>{message}</p>

        {/* Texnik tafsilotlar */}
        {(path || statusCode || traceId) && (
          <div style={s.detailBox}>
            {path && (
              <div style={s.detailRow}>
                <span style={s.label}>Endpoint:</span>
                <span>{path}</span>
              </div>
            )}
            {statusCode && (
              <div style={s.detailRow}>
                <span style={s.label}>Status:</span>
                <span>HTTP {statusCode}</span>
              </div>
            )}
            {traceId && (
              <div style={s.detailRow}>
                <span style={s.label}>TraceId:</span>
                <span>{traceId}</span>
              </div>
            )}
          </div>
        )}
      </div>

      <button onClick={() => window.location.reload()} style={s.retryBtn}>
        Qayta urinish
      </button>
    </div>
  );
}
